'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationTitle } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { mergeSlotProps } from "../internals/mergeSlotProps.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversationTitle');
const ChatConversationTitleStyled = styled('div', {
  name: 'MuiChatConversation',
  slot: 'Title',
  overridesResolver: (_, styles) => styles.title
})(({
  theme
}) => ({
  margin: 0,
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
const ChatConversationTitle = /*#__PURE__*/React.forwardRef(function ChatConversationTitle(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversationTitle'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationTitle, _extends({
    ref: ref
  }, other, {
    slots: _extends({}, slots, {
      title: slots?.title ?? ChatConversationTitleStyled
    }),
    slotProps: _extends({}, slotProps, {
      title: mergeSlotProps({
        className: clsx(classes.title, className),
        sx
      }, slotProps?.title)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversationTitle.displayName = "ChatConversationTitle";
process.env.NODE_ENV !== "production" ? ChatConversationTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatConversationTitle };